import { routerReducer as routing } from 'react-router-redux'
import candidatesData from './candidatesData'
import resumesData from './resumesData'
import templatesData from './templatesData'
import { currentPage, authToken, activeCandidateId, conversionInProgress, targetFileNamesData } from './genericReducers'
import { renameResumeModal } from './modals'
import candidateDetails from './candidateDetails'

export default {
	routing,
	candidatesData,
	resumesData,
	templatesData,
	currentPage,
	authToken,
	activeCandidateId,
	conversionInProgress,
	renameResumeModal,
	targetFileNamesData,
	candidateDetails
}